import * as angular from 'angular';
import * as _ from 'lodash';
import {SectionActivity} from "../../models/activity/shopActivity";
import template from './sectionHistory.tpl.html';

export interface SectionHistoryData {
  section: SectionActivity;
}

export function openSectionHistory(data: SectionHistoryData,
                                   $modal: mm.foundation.modal): angular.IPromise<any> {
  return $modal.open({
    template: template,
    controller: 'SectionHistoryCtrl as historyCtrl',
    resolve: {
      data: function() {
        return data;
      }
    }
  }).result;
}

export default angular.module('aps.controller.sectionHistory', [])
  .controller('SectionHistoryCtrl', sectionHistoryCtrl)
  .name;

function sectionHistoryCtrl($modalInstance: mm.foundation.modalInstance,
                            data: SectionHistoryData) {
  let vm = this;
  vm.section = data.section;
  vm.latestTools = _.values(data.section.latestTools);

  vm.close = function() {
    $modalInstance.close();
  };
}



// WEBPACK FOOTER //
// ./src/app/controllers/toolHistory/sectionHistory.controller.ts